<template>
  <div class="page" style="position: fixed">
    <div class="container">
      <div>
        <div v-if="(resource.filetype.indexOf('pdf') !== -1)" class="preview">
          <!-- <PDFViewer
            :source="resource.resource_url"
            :settings="{ defaultZoom: zoom }"
            style="
              height: 100%;
              width: 100vw;
              min-width: unset;
            "
            @download="handleDownload"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
            @update:zoom="(value) => this.zoom = value"
            ref="pdf-viewer"
          /> -->
          <!-- <vue-pdf-app :pdf="resource.resource_url" @open="openHandler"></vue-pdf-app> -->

          <!-- <iframe height="100%" width=100% :src="resource.resource_url" ></iframe> -->
          <PDFJSViewer path="/lib/web/viewer.html" :fileName="resource.resource_url" style="width: 100%; height: 100%"/>
        </div>
        <div v-else class="preview img">
          <img :src="resource.resource_url" />
        </div>
          
        <div
          v-if="type !== 'customer'"
          id="floating-button"
          ref="floating-button"
        >
          <el-button
            type="primay"
            round
            @click="moveToReservation"
          >
            <span>전화상담요청</span>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
// import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer';
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import 'vue-pdf-app/dist/icons/main.css';
import PDFJSViewer from './PDFJSViewer'

import Footer from "../../view/layout/Footer.vue";

export default {
  data() {
    return {
      resource: {
        _id: '',
        resource_type: '',
        filetype: '',
        resource_key: ''
      },
      customer_id: '',
      estimate_id: '',
      contract_id: '',
      type: '',
      formData: {},
      reservationUrl: '',
      admin_email: '',
      touches: 0,
      scale: undefined,
      distance: 0,
      dist: 0,
      zoom: 200,
      scrollY: 0,
      scrollX: 0,
      a_id_email: ''
    }
  },
  components: {
    Footer,
    // PDFViewer,
    VuePdfApp,
    PDFJSViewer
  },
  mounted() {
    this.resource._id = this.$route.query.i_id;
    this.type = this.$route.query.i_type;

    if (this.type === 'customer') {
      this.getAdmin(this.$route.query.a_id);
    }

    window.addEventListener('resize', this.resizeEventHandler);

    this.init();
    this.resizeEventHandler();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEventHandler);
  },
  methods: {
    handleDownload(source) {
      let req = new XMLHttpRequest();
      req.open("GET", source.src, true);
      req.responseType = "blob";
      req.onload = function () {
        let blob = new Blob([req.response], { type: "application/octetstream" });
        let fileName = source.filename;

        let isIE = false || !!document.documentMode;
        if (isIE) {
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          const url = window.URL || window.webkitURL;
          const link = url.createObjectURL(blob);
          let a = document.createElement("a");
          a.setAttribute("download", fileName);
          a.setAttribute("href", link);
          a.setAttribute('target', '_blank');
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
      req.send();
    },
    getAdmin(admin_id) {
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/www/admin/${admin_id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return; 
        }
        
        this.admin_email = data.admin_email;
        this.a_id_email = data.admin_email;
      });
    },
    getResource() {
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/www/resources/${this.resource._id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return; 
        }

        this.resource = data;
        
        if (this.type !== 'customer') {
          const ectype = {
            estimate: this.formData.estimate_type,
            contract: this.formData.contract_type
          }[this.type];
          
          this.reservationUrl = `/reservation?customer=${this.formData.customer_id}&adminj=${this.formData.admin_id}&admin_id=${this.formData.admin_id}&ectype=${ectype}&source=${this.resource.resource_tag}&memo=`;
        }

        this.sendHangout();
        this.sendHangoutImg();
      })
    },
    sendHangout() {
      const receiver = this.admin_email;
      const contents = {
        estimate: `[홈페이지 ${this.resource.resource_tag} 방문] ${this.formData.customerName} 고객님께서 ${this.formData.estimate_type}보험 ${this.resource.resource_tag}를 확인 중입니다.`,
        contract: `[홈페이지 ${this.resource.resource_tag} 방문] ${this.formData.customerName} 고객님께서 ${this.formData.contract_type}보험 ${this.resource.resource_tag}를 확인 중입니다.`,
        customer: `[홈페이지 ${this.resource.resource_tag} 방문] ${this.formData.customer_name} 고객님께서 ${this.resource.resource_tag}를 확인 중입니다.`,
      }[this.type];

      this.$store.dispatch( "etc/sendHangout", {
        "rp": receiver,
        "mg" : contents
      })
    },
    sendHangoutImg() {
      if (this.$route.query.a_id) {
        this.$store.dispatch('etc/sendHangout', {
          "rp": this.a_id_email,
          "mg": `[이미지 페이지 방문] ${this.formData.customer_name} 고객님께서 ${this.resource.filename}을 확인 중입니다.`
        })
      }
    },
    init() {
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/crm/${this.type}/${this.$route.query.t_id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return; 
        }

        this.formData = data;

        if (data.admin_email) {
          this.admin_email = data.admin_email;
        }

        this.getResource();
      })
    },
    moveToReservation() {
      this.$router.push(this.reservationUrl);
    },
    handleTouchStart(e) {
      e.preventDefault();
      const { touches } = e;
      this.touches = touches.length;
      this.scrollY = e.changedTouches[0].screenY;
      this.scrollX = e.changedTouches[0].screenX;

      if (this.touches === 2) {
        this.distance = Math.hypot(e.touches[0].screenX - e.touches[1].screenX, e.touches[0].screenY - e.touches[1].screenY);
      }
    },
    handleTouchMove(event) {
      event.preventDefault();
      const { touches } = event;
      this.touches = touches.length;

      if (this.touches === 2) {
        this.dist = Math.hypot(touches[0].screenX - touches[1].screenX, touches[0].screenY - touches[1].screenY);
      }
    },
    handleTouchEnd(event) {
      let isModifyZoomLevel = true;
      
      if (this.touches === 1) {
        const scrollTop = this.$refs['pdf-viewer'].$refs['viewer'].$refs['viewerScroller'].scrollTop;
        const currentY = event.changedTouches[0].screenY;
        const currentX = event.changedTouches[0].screenX;
        let scrollY = this.scrollY > currentY ? 100 : -100;
        let scrollX = this.scrollX > currentX ? 100 : -100;

        if (scrollTop < 0) {
          scrollY = 0;
        }

        this.$refs['pdf-viewer'].$refs['viewer'].$refs['viewerScroller'].scrollBy({
          top: scrollY,
          left: scrollX,
          behavior: 'smooth'
        });
        return;
      }

      if (this.dist >= this.distance) {
        if (this.zoom === 500) {
          return;
        }

        this.zoom += 50;
      } else {
        if (this.zoom <= 100) {
          return;
        }

        this.zoom -= 50;
        isModifyZoomLevel = false;
      }

      this.$refs['pdf-viewer'].$refs['control'].handleModifyZoomLevel(isModifyZoomLevel);
    },
    resizeEventHandler() {
      const { userAgent } = window.navigator;
      const isTouchDevice = /iPhone|iPad|iPod|Android/i.test(userAgent);

      document.getElementById('site-header').style.display = isTouchDevice ? 'none' : 'block';
      document.getElementById('site-container').style.paddingTop = isTouchDevice ? '0px' : '6.14rem';

      if (document.querySelector('.pdf-viewer__body')) {
        document.querySelector('.pdf-viewer__body').style.height = isTouchDevice ? 'calc(100% - 108px)' : 'calc(100% - 142px)';
      }

      if (isTouchDevice) {
        // document.querySelector("meta[name=viewport]").setAttrbute("content",  "width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=3.0, user-scalable=yes");
        document.querySelector("meta[name=viewport]").content = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=3.0, user-scalable=yes'
      }
    },
    openHandler(pdfApp) {
      window._pdfApp = pdfApp;
    }
  }
}
</script>

<style lang="scss" scoped>
.page, .container {
  height: 100%;
  width: 100%;

  .container {
    > div {
      height: 100%;
      
      .preview {
        touch-action: pinch-zoom;
        height: calc(100% - 86px);
        overflow-y: auto;

        img {
          margin: 0 auto;
        }

        @include media-mobile {
          height: 100%;

          &.img {
            height: inherit;

            img {
              overflow-y: auto;
            }
          }
        }
      }

      #floating-button {
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 100;
        margin: 0 auto;
        background: rgba(0, 129, 131, 0.5);
        display: block;

        button {
          display: flex;
          margin: 1*$unit auto;
          width: auto;
          background: #174be5;
          border: #174be5;
          color: #fff;
          border-radius: 44.4px;

          span {
            font-size: 1.2*$unit;
            display: inline-block;
            padding: 0.2*$unit $unit;
            margin-left: 0.5*$unit;
          }
        }

        @include media-mobile {
          background: rgba(0, 0, 0, 0.8);
        }
      }

      .pdf-viewer {
        /deep/ .pdf-viewer__header {
          position: fixed;
          width: 100%;
        }
        /deep/ .pdf-viewer__body {
          margin-top: 56px;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>